module.exports = __webpack_public_path__ + "static/boost-74409a607f786ddc10aa3747b27909ef.jpg";